import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function ProcessSection() {
  const {
    lang
  } = useLanguage();
  const steps = [{
    n: '01',
    title: 'Sesión Diagnóstico',
    titleEn: 'Diagnostic Session',
    text: 'Analizamos tu situación, identificamos qué necesitas y te entregamos un plan claro. 30 minutos que lo cambian todo.',
    textEn: 'We analyze your situation, identify what you need, and deliver a clear plan. 30 minutes that change everything.'
  }, {
    n: '02',
    title: 'Estrategia e identidad',
    titleEn: 'Strategy & identity',
    text: 'Definimos tu mensaje, tu posicionamiento y la identidad visual que te representa con autenticidad.',
    textEn: 'We define your message, your positioning, and the visual identity that represents you authentically.'
  }, {
    n: '03',
    title: 'Construcción',
    titleEn: 'Construction',
    text: 'Diseñamos y desarrollamos tu presencia digital completa — web, sistema de cobro, dominio y más.',
    textEn: 'We design and develop your complete digital presence — website, payment system, domain, and more.'
  }, {
    n: '04',
    title: 'Lanzamiento y acompañamiento',
    titleEn: 'Launch & accompaniment',
    text: 'Recibes todo listo, con un dashboard claro y acompañamiento real para crecer con propósito.',
    textEn: 'You receive everything ready, with a clear dashboard and real accompaniment to grow with purpose.'
  }];
  return <section id="proceso" className="py-32 lg:py-44 bg-inkova-cream" data-id="element-329">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-330">
        <div className="mb-20 max-w-2xl" data-id="element-331">
          <span className="block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary mb-8" data-id="element-332">
            {lang === 'es' ? 'NUESTRO PROCESO' : 'OUR PROCESS'}
          </span>
          <h2 className="font-serif text-[32px] sm:text-[4vw] lg:text-[48px] leading-[1.1] tracking-[-0.5px] text-inkova-dark" data-id="element-333">
            {lang === 'es' ? <>
                Un camino con{' '}
                <em className="italic text-inkova-lavender" data-id="element-334">claridad</em> en
                cada paso.
              </> : <>
                A path with{' '}
                <em className="italic text-inkova-lavender" data-id="element-335">clarity</em> at
                every step.
              </>}
          </h2>
        </div>

        <div className="flex flex-col" data-id="element-336">
          {steps.map((step, index) => <motion.div key={step.n} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          ease: 'easeOut',
          delay: index * 0.1
        }} className="grid grid-cols-1 lg:grid-cols-[120px_1fr_1.2fr] gap-6 lg:gap-12 items-baseline py-12 border-t border-inkova-border first:border-t-0" data-id="element-337">
              <span className="font-serif text-[40px] lg:text-[56px] text-inkova-lavender/60 leading-none" data-id="element-338">
                {step.n}
              </span>
              <h3 className="font-serif text-[24px] lg:text-[30px] text-inkova-dark leading-tight" data-id="element-339">
                {lang === 'es' ? step.title : step.titleEn}
              </h3>
              <p className="text-[16px] text-inkova-dark/65 font-light leading-[1.8] max-w-[440px]" data-id="element-340">
                {lang === 'es' ? step.text : step.textEn}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}